<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 684.4 1043">
      <g font-size="40" font-family="sans-serif" letter-spacing="0" word-spacing="0">
        <text x="583.4" y="29.5" transform="translate(1.77 .183)">
          <tspan>Vcc</tspan>
        </text>
        <text x="583.4" y="1035.2" transform="translate(1.77 .183)">
          <tspan>P2.0</tspan>
        </text>
        <text x="583.4" y="982.6" transform="translate(1.77 .183)">
          <tspan>P2.1</tspan>
        </text>
        <text x="583.4" y="930" transform="translate(1.77 .183)">
          <tspan>P2.2</tspan>
        </text>
        <text x="583.4" y="876.9" transform="translate(1.77 .183)">
          <tspan>P2.3</tspan>
        </text>
        <text x="583.4" y="824.3" transform="translate(1.77 .183)">
          <tspan>P2.4</tspan>
        </text>
        <text x="583.4" y="771.1" transform="translate(1.77 .183)">
          <tspan>P2.5</tspan>
        </text>
        <text x="583.4" y="717.9" transform="translate(1.77 .183)">
          <tspan>P2.6</tspan>
        </text>
        <text x="583.4" y="665.3" transform="translate(1.77 .183)">
          <tspan>P2.7</tspan>
        </text>
        <text x="583.4" y="612.2" transform="translate(1.77 .183)">
          <tspan>PSEN</tspan>
        </text>
        <text x="583.4" y="559.6" transform="translate(1.77 .183)">
          <tspan>ALE</tspan>
        </text>
        <text x="583.4" y="507.5" transform="translate(1.77 .183)">
          <tspan>EA</tspan>
        </text>
        <text x="583.4" y="82.7" transform="translate(1.77 .183)">
          <tspan>P0.0</tspan>
        </text>
        <text x="583.4" y="135.8" transform="translate(1.77 .183)">
          <tspan>P0.1</tspan>
        </text>
        <text x="583.4" y="189" transform="translate(1.77 .183)">
          <tspan>P0.2</tspan>
        </text>
        <text x="583.4" y="242.2" transform="translate(1.77 .183)">
          <tspan>P0.3</tspan>
        </text>
        <text x="583.4" y="295.3" transform="translate(1.77 .183)">
          <tspan>P0.4</tspan>
        </text>
        <text x="583.4" y="348.5" transform="translate(1.77 .183)">
          <tspan>P0.5</tspan>
        </text>
        <text x="583.4" y="401.7" transform="translate(1.77 .183)">
          <tspan>P0.6</tspan>
        </text>
        <text x="583.4" y="454.8" transform="translate(1.77 .183)">
          <tspan>P0.7</tspan>
        </text>
        <text x="583.4" y="29.5" transform="translate(-582.98 .182)">
          <tspan>P1.0</tspan>
        </text>
        <text x="583.4" y="1035.2" transform="translate(-582.98 .182)">
          <tspan>GND</tspan>
        </text>
        <text x="583.4" y="982.6" transform="translate(-582.98 .182)">
          <tspan>XTAL1</tspan>
        </text>
        <text x="583.4" y="930" transform="translate(-582.98 .182)">
          <tspan>XTAL2</tspan>
        </text>
        <text x="583.4" y="876.9" transform="translate(-582.98 .182)">
          <tspan>P3.7</tspan>
        </text>
        <text x="583.4" y="824.3" transform="translate(-582.98 .182)">
          <tspan>P3.6</tspan>
        </text>
        <text x="583.4" y="771.1" transform="translate(-582.98 .182)">
          <tspan>P3.5</tspan>
        </text>
        <text x="583.4" y="717.9" transform="translate(-582.98 .182)">
          <tspan>P3.4</tspan>
        </text>
        <text x="583.4" y="665.3" transform="translate(-582.98 .182)">
          <tspan>P3.3</tspan>
        </text>
        <text x="583.4" y="612.2" transform="translate(-582.98 .182)">
          <tspan>P3.2</tspan>
        </text>
        <text x="583.4" y="559.6" transform="translate(-582.98 .182)">
          <tspan>P3.1</tspan>
        </text>
        <text x="583.4" y="507.5" transform="translate(-582.98 .182)">
          <tspan>P3.0</tspan>
        </text>
        <text x="583.4" y="82.7" transform="translate(-582.98 .182)">
          <tspan>P1.1</tspan>
        </text>
        <text x="583.4" y="135.8" transform="translate(-582.98 .182)">
          <tspan>P1.2</tspan>
        </text>
        <text x="583.4" y="189" transform="translate(-582.98 .182)">
          <tspan>P1.3</tspan>
        </text>
        <text x="583.4" y="242.2" transform="translate(-582.98 .182)">
          <tspan>P1.4</tspan>
        </text>
        <text x="583.4" y="295.3" transform="translate(-582.98 .182)">
          <tspan>P1.5</tspan>
        </text>
        <text x="583.4" y="348.5" transform="translate(-582.98 .182)">
          <tspan>P1.6</tspan>
        </text>
        <text x="583.4" y="401.7" transform="translate(-582.98 .182)">
          <tspan>P1.7</tspan>
        </text>
        <text x="583.4" y="454.8" transform="translate(-582.98 .182)">
          <tspan>RST</tspan>
        </text>
      </g>
      <g fill="#9e9e9e" stroke="#000" transform="translate(-19.082 -4.887)">
        <rect width="399" height="1040.1" x="-571.5" y="7.3" transform="scale(-1 1)" ry="5.2" rx="4.3"/>
      </g>
      <text x="250.9" y="565.3" font-size="107.1" font-family="sans-serif" transform="translate(-19.082 -3.816)">
        <tspan>8051</tspan>
      </text>
      <g fill="none" stroke="#000" stroke-width="3.1">
        <g transform="translate(59.526 -.778) scale(.8422)">
          <circle class="high" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 51.96) scale(.8422)">
          <circle id="port00" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 104.696) scale(.8422)">
          <circle id="port01" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 157.433) scale(.8422)">
          <circle id="port02" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 210.17) scale(.8422)">
          <circle id="port03" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 262.906) scale(.8422)">
          <circle id="port04" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 315.643) scale(.8422)">
          <circle id="port05" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 368.38) scale(.8422)">
          <circle id="port06" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 421.117) scale(.8422)">
          <circle id="port07" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 473.854) scale(.8422)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 526.59) scale(.8422)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 579.328) scale(.8422)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 632.064) scale(.8422)">
          <circle id="port27" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 684.8) scale(.8422)">
          <circle id="port26" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 737.538) scale(.8422)">
          <circle id="port25" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 790.275) scale(.8422)">
          <circle id="port24" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 843.012) scale(.8422)">
          <circle id="port23" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 895.75) scale(.8422)">
          <circle id="port22" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 948.485) scale(.8422)">
          <circle id="port21" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="translate(59.526 1001.222) scale(.8422)">
          <circle id="port20" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 -.778)">
          <circle id="port10" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 51.96)">
          <circle id="port11" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 104.696)">
          <circle id="port12" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 157.433)">
          <circle id="port13" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 210.17)">
          <circle id="port14" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 262.906)">
          <circle id="port15" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 315.643)">
          <circle id="port16" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 368.38)">
          <circle id="port17" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 421.117)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 473.854)">
          <circle id="port30" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 526.59)">
          <circle id="port31" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 579.328)">
          <circle id="port32" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 632.064)">
          <circle id="port33" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 684.8)">
          <circle id="port34" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 737.538)">
          <circle id="port35" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 790.275)">
          <circle id="port36" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 843.012)">
          <circle id="port37" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 895.75)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 948.485)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
        <g transform="matrix(-.8422 0 0 .8422 646.404 1001.222)">
          <circle class="low" cx="607" cy="19.3" r="16"/>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { forEach, range } from 'lodash';

export default {
  computed: mapGetters([
    'getP0',
    'getP1',
    'getP2',
    'getP3',
  ]),
  mounted() {
    const toBin = this.$store.state.utils.convertToBin;
    this.$store.subscribe(() => {
      forEach(range(4), (i) => {
        const port = toBin(this[`getP${i}`]());
        forEach(range(8), (j) => {
          const elt = this.$el.querySelector(`#port${i}${j}`);
          elt.setAttribute('class', port[7 - j] === '1' ? 'high' : 'low');
        });
      });
    });
  },
};
</script>

<style scoped>
.high {
  fill: red;
}

.low {
  fill: none;
}
</style>



// WEBPACK FOOTER //
// PinDiagram.vue?4e50fdc6